import React from 'react';
import cn from 'classnames';
import styles from './Item.module.sass';
import LetterAvatar from '../../../LetterAvatar';

const Item = ({ className, student, onClick }) => {
  return (
    <div className={cn(styles.item, className)} onClick={onClick}>
      <div className={styles.preview}>
        <LetterAvatar firstName={student.first_name} lastName={student.last_name} size={40} />
      </div>
      <div className={styles.details}>
        <div className={styles.title}>{student.first_name} {student.last_name}</div>
        <div className={styles.content}>{student.email}</div>
      </div>
    </div>
  );
};

export default Item;